import { React, useState } from "react";
import ForumTopic from "./ForumTopic";
import Pagination from "./../Pagination";

function CategoryList({ categories }) {
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;

    // Calculate current posts to display
    const indexOfLastPost = currentPage * itemsPerPage;
    const indexOfFirstPost = indexOfLastPost - itemsPerPage;
    const currentPosts = categories.slice(indexOfFirstPost, indexOfLastPost);

    // Change page
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    return (
        <section className="flex flex-col w-full">
            <div className="flex gap-4 items-start px-4 py-1 border-b border-gray-200 max-sm:hidden">
                <h2 className="flex-1 text-base font-semibold leading-7 text-gray-400">
                    Tên chủ đề
                </h2>
                <div className="text-base font-semibold leading-7 text-gray-400 w-[120px]">
                    Tổng số bài viết
                </div>
                {/* <div className="text-base font-semibold leading-7 text-gray-400 w-[280px]">
                    Người tạo
                </div> */}
            </div>

            {currentPosts.map((topic, index) => (
                <ForumTopic
                    key={index}
                    id={topic.id}
                    name={topic.title}
                    icon={topic.icon}
                    postCount={topic.totalPost}
                />
            ))}
            <Pagination
                currentPage={currentPage}
                totalItems={categories.length}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
            />
        </section>
    );
}

export default CategoryList;
